<template>
  <transition name="index-fade" mode="out-in">
    <div id="index" :key="isShow" :class="isShow ? 'open' : 'close'">
      <div class="container">
        <ul id="indexlist">
          <div class="listTitle" :class="[isShow ? 'open' : 'close']">
            <span>목차</span>
            <Ubutton v-if="isShow" size="medium" icon="226" iconSize="xsmall" state="deactive" @click.native="resetCount"/>
            <UbuttonList v-if="isShow" size="xsmall" align="right" :data="[{name: '만들기', state: 'deactive', click: createItem}]"/>
          </div>
          <li class="list" v-if="data.length === 0 && initdata.length === 0">
            <div v-if="isShow">목차가 없습니다</div>
          </li>
          <li v-else class="listcontainer">
            <ul>
              <li class="listItem" v-for="item in initdata" :key="item.index" :class="isShow ? 'open' : 'close'">
                <div v-if="isShow">
                  <span @click="bodyMove(item)">{{ itemName(item) }}</span>
                </div>
                <span v-else @click="bodyMove(item)"><b>[{{ item.count }}]</b></span>
              </li>
              <li class="listItem" v-for="item in data" :key="item.index" :class="isShow ? 'open' : 'close'">
                <div v-if="isShow">
                  <span :class="getStepClass(item)" @click="bodyMove(item)">{{ item.name }}</span>
                  <Ubutton v-if="isStep(1, item)" size="small" icon="227" iconSize="xsmall" :state="(item.step != 1) ? 'deactive' : 'active'" @click.native="changeStep(item, 1)"/>
                  <Ubutton v-if="isStep(2, item)" size="small" icon="228" iconSize="xsmall" :state="(item.step != 2) ? 'deactive' : 'active'" @click.native="changeStep(item, 2)"/>
                  <Ubutton size="small" icon="217" iconSize="xsmall" state="deactive" @click.native="confirm(getRemoveParam(item), removeItem)"/>
                  <Ubutton size="small" icon="222" iconSize="xsmall" state="deactive" @click.native="openEdit(item)"/>
                </div>
                <span v-else @click="bodyMove(item)"><b>[{{ item.count }}]</b></span>
              </li>
            </ul>
          </li>
        </ul>
        <transition name="indexEdit-fade" @enter="enter" @after-leave="leave">
          <ul id="indexedit" v-if="isEdit">
            <div class="listTitle">
              <span>내용 입력하기</span>
              <UbuttonList size="xsmall" align="right" :data="editButtonList"/>
            </div>
            <!-- <Uinput type="text" tag="li" placeholder="목차 이름을 입력해 주세요" @enter="itemSave" @esc="isEdit = false" tabindex="2">
              <span><b>[{{ focus.count }}]</b></span>
            </UInput> -->
            <Uinput type="textarea" tag="li" placeholder="목차 이름을 입력해 주세요" @enter="itemSave" @esc="isEdit = false" v-model="edittext"/>
          </ul>
        </transition>
      </div>
      <div class="indexbutton" :class="isShow ? 'open' : 'close'">
        <Ubutton v-if="!isShow" size="medium" icon="229" iconSize="xsmall" state="deactive" :round="true" @click.native="createItem"/>
        <span v-if="!isShow" class="line"/>
        <Ubutton size="medium" :icon="isShow ? '128 rotate180' : '128'" iconSize="small" state="deactive" :round="true" @click.native="toogleOpen"/>
      </div>
    </div>
  </transition>
</template>

<script>
import Uinput from '@/components/base/UInput.vue'
import ES from '@/components/js/EditorSetting.js'
import {selection, range, resetRange, closest, changeParents, changeTag, hasClass, getTime} from '@/components/js/Utils.js'

var idName = 'uil'

export default {
  props: {
    data: { type: Array },
    initdata: { type: Array },
    isShow: { type: Boolean, default: true },
    type: { type: String, default: 'edit' },
    editType: { type: String },
    range: { type: Range }
  },
  data: function () {
    return {
      editButtonList: [
        {name: '취소', state: 'deactive', click: () => { this.isEdit = false }},
        {name: '등록', state: 'active', click: this.itemSave}
      ],
      viewButtonList: [
        {name: '이전', state: 'deactive', click: () => { this.focus = this.prevfocus }},
        {name: '다음', state: 'deactive', click: () => { this.focus = this.nextfocus }}
      ],
      isEdit: false,
      focus: null,
      isView: false,
      cutData: [],
      edittext: ''
    }
  },
  mounted () {
    console.log(this.$center)
    this.$center.addStepEvent(ES.KEYDOWN, 1, this.keydown)
    this.$center.addStepEvent(ES.CUT, 1, this.cut)
    this.$center.addStepEvent(ES.PASTE, 1, this.paste)
    this.$center.addStepEvent(ES.SELECTION, 1, this.edit_selection)
    this.$center.addStepEvent(ES.REMOVE, 1, this.edit_remove)
    this.$center.addStepEvent(ES.MOUSEDOWN, 1, this.mousedown)
    this.$center.addStepEvent(ES.DRAGSTART, 1, this.dragstart)
  },
  beforeDestroy () {
    this.$center.removeStepEvent(ES.KEYDOWN, this.keydown)
    this.$center.removeStepEvent(ES.CUT, this.cut)
    this.$center.removeStepEvent(ES.PASTE, this.paste)
    this.$center.removeStepEvent(ES.SELECTION, this.edit_selection)
    this.$center.removeStepEvent(ES.REMOVE, this.edit_remove)
    this.$center.removeStepEvent(ES.MOUSEDOWN, this.mousedown)
    this.$center.removeStepEvent(ES.DRAGSTART, this.dragstart)
  },
  name: 'indexlist',
  watch: {
    initdata (val) {
      console.log('initdata', val)
    }
  },
  computed: {
    prevfocus () {
      var idx = this.data.indexOf(this.focus) - 1
      return (idx < 0) ? this.data[this.data.length - 1] : this.data[idx]
    },
    nextfocus () {
      var idx = this.data.indexOf(this.focus) + 1
      return (idx === this.data.length) ? this.data[0] : this.data[idx]
    }
  },
  methods: {
    itemName (item) {
      return item.name.substring(0, 23) + '...'
    },
    mousedown (e) {
      if (closest(e.target, ES.INDEX)) {
        return ES.TYPE_INDEX
      }
    },
    keydown (e) {
      // console.log('keydown', this, e)
      var s = selection()
      var sn
      switch (e.keyCode || e.which) {
        case 8 :
          // console.log(s, s.anchorNode)
          if (s.anchorOffset === 0 && closest(s.anchorNode, ES.INDEX)) {
            this.confirm(this.getRemoveParam(this.searchItem(closest(s.anchorNode, ES.INDEX).id)), this.removeItem)
            e.preventDefault()
          }
          break
        case 46 :
          if (s.anchorOffset === s.anchorNode.length && closest(s.anchorNode, ES.INDEX)) {
            this.confirm(this.getRemoveParam(this.searchItem(closest(s.anchorNode, ES.INDEX).id)), this.removeItem)
            e.preventDefault()
          }
          break
        case 13 :
        // enter
          switch (this.editType) {
            case ES.TYPE_INDEX :
              // console.log('block enter')
              sn = document.createElement('br')
              range().insertNode(sn)
              resetRange(sn.nextSibling, 0)
              e.preventDefault()
              break
          }
          break
      }
    },
    edit_selection (e) {
      if (ES.hasSelection(this.selectionCheck, this.checkItem).length) {
        return '목차'
      }
    },
    selectionCheck (s, t, ar) {
      if (this.isItem(t) && s.containsNode(t)) {
        ar.push(t)
      }
    },
    isItem (t) {
      return t && t.classList.contains(ES.toINDEX)
    },
    checkItem (t) {
      t = closest(t, ES.INDEX)
      if (t) {
        return this.searchItem(t.id)
      }
      return null
    },
    edit_remove (e) {
      var s = selection()
      var sn = s.anchorNode
      var so = s.anchorOffset
      var en = s.extentNode
      var eo = s.extentOffset
      if (sn === en && closest(s.anchorNode, ES.INDEX)) {

      } else {
        ES.hasSelection(this.selectionCheck, this.checkItem).forEach((n) => {
          var t = this.getElement(n)
          console.log(t)
          t = changeTag(t, ES.ENTER)
          t.align = ES.ALIGN_LEFT
          this.data.splice(this.data.indexOf(n), 1)
        })
        if (so !== s.anchorOffset || eo !== s.extentOffset) {
          resetRange(sn, so, en, eo)
        }
        this.resetCount()
      }
    },
    cut (e) {
      var s = selection()
      var t = closest(s.anchorNode, ES.INDEX)
      console.log(s.anchorOffset, s.extentOffset)
      if (t && ((s.anchorOffset === 0 && s.extentOffset === t.outerText.length) || (s.anchorOffset === t.outerText.length && s.extentOffset === 0))) {
        var c = (e.clipboardData || window.clipboardData || e.originalEvent.clipboardData)
        c.setData('text/html', t.outerHTML)
        this.data.splice(this.data.indexOf(this.searchItem(t.id)), 1)
        t.parentNode.removeChild(t)
        e.preventDefault()
      }
    },
    paste (e) {
      e.pasteHTML.querySelectorAll(ES.INDEX).forEach((item) => {
        var t = getTime()
        item.id = idName + t
        this.data.push({id: idName + t, count: this.data.length, name: item.outerText, step: parseInt(item.nodeName.substring(1)) - 2})
      })
      setTimeout(() => {
        this.resetCount()
      })
    },
    changeStep (item, step) {
      if (item.step === step) {
        item.step = 0
      } else {
        item.step = step
      }
      var t = this.getElement(item)
      var al = hasClass(t, [ES.ALIGN_LEFT, ES.ALIGN_RIGHT, ES.ALIGN_CENTER, ES.ALIGN_JUSTIFY])
      switch (item.step) {
        case 0 :
          t = changeTag(t, 'h2')
          break
        case 1 :
          t = changeTag(t, 'h3')
          break
        case 2 :
          t = changeTag(t, 'h4')
          break
      }
      item.element = t
      t.id = item.id
      t.classList.add(ES.toINDEX, 'u_tag', al)
      this.$emit('update:data', this.data)
    },
    createItem () {
      console.log('create')
      this.$emit('update:isShow', this.true)
      this.focus = this.itemCreate()
      this.$emit('create', this.focus)
      this.edittext = this.focus.innerText
      this.isEdit = true
      this.resetCount()
    },
    itemCreate () {
      var i = this.data.length + 1
      console.log(this.range)
      var t = closest(this.range.startContainer, ES.ENTER)
      changeParents(t, 'span', 'span', 'u_tag')
      changeParents(t, 'b', 'b', 'u_tag')
      changeParents(t, 'i', 'i', 'u_tag')
      changeParents(t, 'u', 'u', 'u_tag')
      changeParents(t, 'font', 'font', 'u_tag')
      changeParents(t, 'strike', 'strike', 'u_tag')
      var al = t.align
      t = changeTag(t, 'h2')
      var td = getTime()
      t.id = idName + td
      t.classList.add(ES.toINDEX, 'u_tag', al)
      this.data.push({id: idName + td, count: i, name: t.outerText, step: 0, isEdit: true})
      if (t.nextSibling === null) {
        var temp = document.createElement(ES.ENTER)
        temp.align = ES.ALIGN_LEFT
        temp.appendChild(document.createElement('br'))
        t.parentNode.appendChild(temp)
      }
      resetRange(t.childNodes[0], 0)
      this.$emit('update:editType', ES.TYPE_INDEX)
      return t
    },
    toogleOpen () {
      console.log('toogle')
      this.resetCount()
      this.isEdit = false
      this.isView = false
      this.$emit('update:isShow', !this.isShow)
    },
    getRemoveParam (item) {
      return {
        target: item.name,
        message: '목차를 삭제 하시겠습니까?',
        icon: 'edit_delete',
        param: item
      }
    },
    removeItem (e) {
      if (e.result) {
        var item = e.param
        var t = this.getElement(item)
        console.log(t)
        if (t !== null) {
          t = changeTag(t, ES.ENTER)
          t.align = ES.ALIGN_LEFT
        }
        this.data.splice(this.data.indexOf(item), 1)
        this.resetCount()
      }
    },
    enter: function (el, done) {
      this.$emit('onChange', 'enter')
      // var t = document.querySelector('#indexedit textarea')
      // t.value = (this.focus.name === undefined) ? '' : this.focus.name
      document.querySelector('#indexedit textarea').focus()
      // t = document.querySelector('#footnoteedit textarea')
      // t.value = (this.focus.message === undefined) ? '' : this.focus.message
    },
    leave: function (el, done) {
      this.focus = null
      this.$emit('update:isCreate', false)
      this.$emit('onChange', 'leave')
    },
    bodyMove (e) {
      this.getElement(e).scrollIntoView()
    },
    openEdit (e) {
      this.focus = e
      this.isEdit = true
      this.edittext = this.focus.name
    },
    searchCutItem (id) {
      var i
      for (i = 0; i < this.cutData.length; i++) {
        if (this.cutData[i].id === id) {
          return this.cutData.splice(i, 1)[0]
        }
      }
      return null
    },
    searchItem (id) {
      return this.data.find((el) => el.id === id)
    },
    changeUp (e) {
      var idx = this.data.indexOf(e)
      if (idx) {
        var item = this.data.splice(idx, 1)
        this.data.splice(idx - 1, 0, item[0])
        this.resetCount()
      }
    },
    changeDown (e) {
      var idx = this.data.indexOf(e)
      var item = this.data.splice(idx, 1)
      this.data.splice(idx + 1, 0, item[0])
      this.resetCount()
    },
    itemSave () {
      console.log('itemsave')
      this.focus.name = document.querySelector('#indexedit textarea').value
      this.isEdit = false
    },
    resetCount () {
      this.initdata.forEach((n, i) => {
        n.count = i + 1
      })
      document.querySelectorAll('.u_index').forEach((n, i) => {
        console.log(n)
        if (n) {
          var d = this.searchItem(n.id)
          if (d) {
            d.count = i + this.initdata.length + 1
          }
        }
      })
      this.data.sort((a, b) => {
        return a.count > b.count ? 1 : -1
      })
      this.$emit('update:data', this.data)
    },
    openView (e) {
      this.focus = e
      this.isView = true
    },
    getElement (t) {
      if (!t.element || !t.element.tagName) {
        t.element = document.querySelector('#' + t.id)
      }
      return t.element
    },
    isStep (btn, item) {
      var idx = this.data.indexOf(item)
      switch (idx) {
        case 0 :
          switch (btn) {
            case 1 :
              return true
            default :
              return false
          }
        default :
          if (this.data[idx - 1].step === 0) {
            return (btn === 1)
          } else {
            return true
          }
      }
    },
    getStepClass (item) {
      switch (item.step) {
        case 1 :
          return 'step1'
        case 2 :
          return 'step2'
        default :
          return ''
      }
    },
    dragstart (e) {
    }
  },
  components: {
    Uinput
  }
}
</script>

<style>
h2 {
  font-size: 1.3em;
}
h2.left, h3.left, h4.left {
  text-align: left;
}
h2.right, h3.right, h4.right {
  text-align: right;
}
h2.center, h3.center, h4.center {
  text-align: center;
}
h2.justify, h3.justify, h4.justify {
  text-align: justify;
}
</style>

<style scoped>
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
#index {
  position: relative;
  display: flex;
  flex-direction: column;
  top: 0;
  right: 0;
  height: 100%;
  width: 300px;
  color: var(--text-base);
  background-color: var(--bg-white);
}
#index.open {
  width: 300px;
}
#index.close {
  width: 55px;
}
#index .container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.listcontainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.listTitle {
  display: inline-flex;
  height: 40px;
  padding-left: 5px;
  padding-right: 5px;
  align-items: center;
  color: var(--text-title);
  background-color: var(--disable);
  box-sizing: border-box;
}
.listTitle.open.edit {
  justify-content: flex-start;
}
.listTitle.open.view {
  justify-content: center;
}
.listTitle.close {
  justify-content: center;
}
.listTitle > span:first-child{
  display: flex;
  flex: none;
  margin: 0;
  max-width: 100%;
  font-weight: bold;
}
.list {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
#indexlist,
#indexedit {
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--line-guide);
}
#indexlist {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.listItem {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 50px;
  padding-left: 5px;
  padding-right: 5px;
  border-bottom: 1px solid var(--line-guide);
  overflow: hidden;
  font-size: 13px;
}
.listItem > span {
  flex: none;
  margin: 0;
  display: flex;
  flex: auto;
  height: 100%;
  align-items: center;
  background-color: var(--bg-white);
  cursor: pointer;
  justify-content: center;
}
.listItem.open {
  justify-content: flex-start;
}
.listItem.close {
  justify-content: center;
}
.listItem.open > div > span {
  display: -webkit-box;
  flex: auto;
  width: 120px;
  max-height: 40px;
  /* height: 100%; */
  /* vertical-align: middle; */
  /* text-align: left; */
  /* align-items: center; */
  margin-left: 10px;
  background-color: var(--bg-white);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -webkit-box-align: start;
  text-align: left;
  /* white-space: nowrap; */
}
.listItem > div {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
#indexedit {
  position: absolute;
  display: flex;
  top: 0;
  right: 0px;
  background-color: var(--bg-white);
  height: 100%;
}
#indexedit li {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0px 5px 0px 5px;
}
#indexedit li span {
  margin: 0px 5px 0px 5px;
}
#indexedit .input {
  margin: 0px 5px 0px 5px;
}
.indexbutton {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  vertical-align: middle;
  cursor: pointer;
  width: 100%;
  border: 1px solid var(--line-guide);
  border-top: none;
  background-color: var(--disable);
}
.indexbutton.open div {
  margin: 5px 5px 5px 5px;
}
.indexbutton.close div {
  margin: 2px 2px 2px 2px
}
.indexbutton span {
  margin: 0 auto;
}
.indexbutton div sub {
  font-size: 0.5em;
  margin-left: -2px;
  margin-bottom: -8px;
}
.indexbutton .line {
  margin: 1px 0px 1px 0px;
  border-bottom: 1px solid var(--line-guide);
}
.indexbutton div {
  width: auto;
  background-color: var(--bg-white);
}
.indexbutton div:hover {
  color: var(--bg-white);
  background-color: var(--deactive);
}
.index-fade-enter-active {
  transition: all .2s ease;
}
.index-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.index-fade-enter, .index-fade-leave-to {
  transform: translateX(300px);
}
.indexEdit-fade-enter-active {
  transition: all .2s ease;
}
.indexEdit-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.indexEdit-fade-enter {
  transform: translateX(200px);
}
.indexEdit-fade-leave-to {
  transform: translateX(300px);
}
.step1 {
  padding-left: 10px;
}
.step2 {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/IndexList.vue